module.exports = __webpack_public_path__ + "img/info.008.890ef523.jpeg";